import Vue from 'vue'
import  VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
Vue.use(VueMeta)
Vue.use(VueRouter)

Vue.use(VueMeta, {
    refreshOnceOnNavigation: true
  })

function lazyView(view) {
    return () => import(`./components/${view}.vue`)
}

const routes = [

    {  path: '/', component: lazyView('Home'), name: 'Home',  },
    //{ path: '/orderconfirm/:404(.*)*', component: lazyView('404'), name: '404',  },
    { path: '/order/:pagename', component: lazyView('Home'), name: 'Home', },
    { path: '/outlets/:bytrainorpnr', component: lazyView('Outlets'), name: 'Outlets', },
    { path: '/station/order-food-in-train-at-:code', component: lazyView('Outletstation'), name: 'Outletstation',  },
    { path: '/store/:storeid/:name', component: lazyView('Store'), name: 'Store', },
    { path: '/store/:bytrainorpnr', component: lazyView('Store'), name: 'Store', },
    { path: '/cart', component: lazyView('Cart'), name: 'Cart',  },
    { path: '/customer-details', component: lazyView('CustomerDetails'), name: 'CustomerDetails',  },
    { path: '/payment', component: lazyView('Payment'), name: 'Payment',  } ,
    { path: '/orderconfirm/:orderid', component: lazyView('Orderconfirm'), name: 'Orderconfirm',  }  ,
    { path: '/track-order', component: lazyView('Trackorder'), name: 'Trackorder',  }   ,
    { path: '/myaccount', component: lazyView('Myaccount'), name: 'Myaccount',
        beforeEnter: (to, from, next) => {
            var logtoken = localStorage.getItem('logingToken');
            if (logtoken) {
              next();
            } else {
              next('/login');
            }
          }
    },
    { path: '/app-share', component: lazyView('Appshare'), name: 'Appshare', },
    { path: '/login', component: lazyView('Login'), name: 'Login', } ,
    { path: '/register', component: lazyView('Register'), name: 'Register', },
    { path: '/search', component: lazyView('Search'), name: 'Search', },
    { path: '/myprofile', component: lazyView('Myprofile'), name: 'Myprofile', } ,
    { path: '/myorder', component: lazyView('Myorder'), name: 'myorder', } ,
    { path: '/more', component: lazyView('Morepage'), name: 'Morepage', } ,
    { path: '/group-order', component: lazyView('Grouporder'), name: 'Grouporder', } ,
    { path: '/restaurant-signup', component: lazyView('Restaurantsignup'), name: 'Restaurantsignup', } ,
    { path: '/about-us', component: lazyView('Aboutus'), name: 'Aboutus', } ,
    { path: '/blogs', component: lazyView('Blogs'), name: 'blogs', } ,
    { path: '/blog/:postname', component: lazyView('Singleblog'), name: 'Singleblog', } ,
    { path: '/how-to-order', component: lazyView('Howtoorder'), name: 'Howtoorder', } ,
    { path: '/contact-us', component: lazyView('Contactus'), name: 'Contactus', } ,
    { path: '/terms-and-condition', component: lazyView('Termandcondition'), name: 'Termandcondition', } ,
    { path: '/privacy-policy', component: lazyView('Privacypolicy'), name: 'Privacypolicy', } ,
    { path: '/cancellation-policy', component: lazyView('Cancellationpolicy'), name: 'Cancellationpolicy',  } ,
    { path: '/disclaimer', component: lazyView('Disclaimer'), name: 'Disclaimer',   }  ,
    { path: '/quality-assurance', component: lazyView('Quality'), name: 'Quality',  }  ,
    { path: '/FAQs', component: lazyView('Faqs'), name: 'FAQs', }  ,
    { path: '/sitemap', component: lazyView('Sitemap'), name: 'sitemap', },



    { path: '/book-train-tickets', component: lazyView('Trainticket'), name: 'Trainticket', },

    { path: '/check-pnr-status', component: lazyView('Checkpnrstatus'), name: 'Checkpnrstatus', },
    { path: '/check-pnr-status/:bytrainorpnr', component: lazyView('Checkpnrstatus'), name: 'Checkpnrstatus', },

    { path: '/train-running-status', component: lazyView('Trainruningstatus'), name: 'Trainruningstatus', },
    { path: '/train-running-status/:trains', component: lazyView('Trainruningstatus'), name: 'Trainruningstatus',},

    { path: '/train-time-table', component: lazyView('Traintimetable'), name: 'Traintimetable', },
    { path: '/train-time-table/:trains', component: lazyView('Traintimetable'), name: 'Traintimetable',},

    { path: '/train-between-stations', component: lazyView('Trainbetweenstations'), name: 'Trainbetweenstations', },
    { path: '/train-between-stations/:trains', component: lazyView('Trainbetweenstations'), name: 'Trainbetweenstations', },

    { path: '/seat-availability', component: lazyView('Seatavailability'), name: 'Seatavailability', },
    { path: '/seat-availability/:trains', component: lazyView('Seatavailability'), name: 'Seatavailability', },

    { path: '/check-coach-position', component: lazyView('Coachposition'), name: 'Coachposition', } ,
    { path: '/check-coach-position/:trains', component: lazyView('Coachposition'), name: 'Coachposition', } ,

    { path: '/fare-calculator', component: lazyView('Farecalculator'), name: 'Farecalculator', },

    { path: '/station-details', component: lazyView('Stationdetails'), name: 'Stationdetails',  },
    { path: '/station-details/:trains', component: lazyView('Stationdetails'), name: 'Stationdetails', } ,

    { path: '/platform-locator', component: lazyView('platformlocator'), name: 'platformlocator', },



    { path: '/food-on-train', component: lazyView('foodontrain'), name: 'foodontrain', },
    { path: '/jain-food-order', component: lazyView('jainfoodorder'), name: 'jainfoodorder', },
    { path: '/railway-food-delivery', component: lazyView('railwayfoodorder'), name: 'railwayfoodorder', },
    { path: '/order-food-in-train-on-whatsapp', component: lazyView('foodonwhatsapp'), name: 'foodonwhatsapp', },
    { path: '/food-in-train', component: lazyView('foodintrain'), name: 'foodintrain', },
    { path: '/food-delivery-in-train', component: lazyView('fooddeliveryintrain'), name: 'fooddeliveryintrain', },
    { path: '/khana-order-in-train', component: lazyView('khanaorderintrain'), name: 'khanaorderintrain', },
    { path: '/irctc-food-booking', component: lazyView('irctcfoodbooking'), name: 'irctcfoodbooking', },
    { path: '/irctc-food-order', component: lazyView('irctcfoodorder'), name: 'irctcfoodorder', },
    { path: '/irctc-ecatering', component: lazyView('irctcecateringservices'), name: 'irctcecateringservices', },

    { path: '/:pagename', component: lazyView('Homeaddons'), name: 'Home',  },
    { path: '/orderconfirm/:404(.*)*', component: lazyView('404'), name: '404',  },

    { path: '/vendor', component: lazyView('Vendor'), name: 'Vendor',
        beforeEnter: (to, from, next) => {
            var logtoken = localStorage.getItem('vendorlogtoken');
            if (logtoken) {
              next();
            } else {
              next('/vendorlogin');
            }
          }
    }
    ,
    { path: '/vendorlogin', component: lazyView('Vendorlogin'), name: 'Vendorlogin', }


]

const router = new VueRouter({
    mode: 'history',
    routes,
})

export default router;
